// 设备检测工具
export const deviceDetect = {
  // 检测是否为移动设备
  isMobile() {
    const userAgent = navigator.userAgent;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileRegex.test(userAgent);
  },

  // 检测是否为平板
  isTablet() {
    const userAgent = navigator.userAgent;
    const tabletRegex = /iPad|Android(?=.*\bMobile\b)(?=.*\bSafari\b)|KFAPWI|LG-V909|GT-P1000|GT-P7510|SCH-I800|SHW-M180S|SGH-T849|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook/i;
    return tabletRegex.test(userAgent);
  },

  // 基于屏幕宽度检测
  isMobileByWidth() {
    return window.innerWidth <= 768;
  },

  // 综合检测
  getDeviceType() {
    if (this.isMobile() || this.isMobileByWidth()) {
      return 'mobile';
    } else if (this.isTablet()) {
      return 'tablet';
    } else {
      return 'desktop';
    }
  },

  // 设置根字体大小
  setRootFontSize() {
    const deviceType = this.getDeviceType();
    const baseSize = deviceType === 'mobile' ? 37.5 : 192; // 移动端37.5px，PC端192px
    document.documentElement.style.fontSize = (window.innerWidth / (deviceType === 'mobile' ? 375 : 1920)) * baseSize + 'px';
  }
};
